import { useState, useMemo, useEffect, } from 'react';

import { useFormik, FormikProvider, FieldArray } from "formik";
import { object, string, number, mixed } from 'yup';

import { IonAlert, IonProgressBar, } from '@ionic/react';

import { useHistory, useLocation } from 'react-router';

import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';

/* My Components */
import DatosInstitucion from './Escuelas/DatosInstitucion';
import DatosFacturacion from './Escuelas/DatosFacturacion';
import Usuario from './Escuelas/Usuario';
import SaveAlumno from './Escuelas/SaveAlumno';
import Pago from './Escuelas/Pago';

import configData from "../../config.json";

const apiUrl = (process.env.NODE_ENV !== 'development') ? configData.EndPoint : configData.EndPointLocal;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    button: {
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    actionsContainer: {
      marginBottom: theme.spacing(2),
    },
    resetContainer: {
      padding: theme.spacing(3),
    },

  }),
);

const testInitialValues = {
  Escuela: {
    DatosInstitucion: {
      nombre: 'Kidkiriki-Autoregistro',
      descripcion: 'Es una institución para aprendizaje continuo',
      direccion: 'Cumbres de los alpes',
      numero: '151',
      colonia: 'Cumbres',
      cp: '26000',
      edo: 'PIEDRAS NEGRAS',
      pais: 'MEXICO',
      telefono: '+528781011009',
      email: 'brandon@gmail.com',
      logo: '',
      numero_alumnos: '12',
      zona_horaria: 'America/Tijuana',
      hora_salida: '23:00',
    },
    DatosFacturacion: {
      nombre: 'Brandon Axell',
      apellidos: 'Ramirez Ruiz',
      razons: 'BRANDON AXELL RUIZ RAMIREZ',
      rfc: 'RURB9507189A7',
      email: 'blackbrandonanswer@gmail.com',
      telefono: '+528781011001',
      calle: 'Rio colorado',
      numero_exterior: '217',
      colonia: 'Nueva Americana',
      codpos: '26070',
      ciudad: 'Piedras Negras',
      estado: 'Coahuila',
    },
    Usuario: {
      nombre: 'Brandon Axell',
      apellido: 'Ruiz Ramirez',
      email: 'brandon_axell@hotmail.com',
      password: 'Abc128*1',
      mobil: '8781011009',
      rol: 'ADMIN'
    },
  },
};

const initialValues = {
  Escuela: {
    DatosInstitucion: {
      nombre: '',
      descripcion: '',
      direccion: '',
      numero: '',
      colonia: '',
      cp: '',
      edo: '',
      pais: '',
      telefono: '',
      email: 'autoregistro@kidkiriki.com',
      logo: '',
      numero_alumnos: '12',
      zona_horaria: '',
      hora_salida: '23:00',
    },
    DatosFacturacion: {
      nombre: '',
      apellidos: '',
      razons: '',
      rfc: '',
      email: '',
      telefono: '',
      calle: '',
      numero_exterior: '',
      colonia: '',
      codpos: '',
      ciudad: '',
      estado: '',
    },
    Usuario: {
      nombre: '',
      apellido: '',
      email: '',
      password: '',
      mobil: '1234567890',
      rol: ''
    },
  },
};

const FILE_SIZE = 160 * 1024;
const SUPPORTED_FORMATS = [
  "image/jpg",
  "image/jpeg",
  "image/gif",
  "image/png"
];

const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

const getSteps = (type: string) => {

  switch (type) {
    case 'MEXICO':
      return [
        'Datos de la institución',
        'Usuario administrador',
        'Datos de facturación',
        'Subscripción y pago',
      ];
    default:
      return [
        'Datos de la institución',
        'Usuario administrador',
        'Subscripción y pago',
      ];
  }

};

const selectValidationSchema = (type?: string) => {
  switch (type) {

    case 'MEXICO':
      return object({
        Escuela: object({
          DatosInstitucion: object({
            nombre: string().required(),
            descripcion: string(),
            direccion: string().required(),
            numero: string().required(),
            colonia: string().required(),
            cp: string().required().min(5).max(5),
            edo: string().required().min(3),
            pais: string().required(),
            telefono: number().required(),
            email: string(),
            logo: mixed()
              .test("FILE_SIZE", "La imagen excede el peso y tamaño permitidido.",
                value => !value || (value && value.size <= FILE_SIZE))
              .test("FILE_FORMAT", "La imagen tiene un formato invalido.",
                value => !value || (value && SUPPORTED_FORMATS.includes(value.type))),
            numero_alumnos: number().required().min(12),
            zona_horaria: string().required(),
            hora_salida: string(),
          }),
          Usuario: object({
            nombre: string().required(),
            apellido: string().required(),
            email: string().required().email(),
            password: string().required('Contraseña requerida').min(3),
            // mobil: string().required().min(10).max(10)
          }),
          DatosFacturacion: object({
            nombre: string().required(),
            apellidos: string().required(),
            razons: string().required(),
            rfc: string().required().test('len', 'Must be exactly 5 characters', (val: any) => val?.length <= 13),
            email: string().required().email(),
            telefono: number().required(),
            calle: string().required(),
            numero_exterior: string().required(),
            colonia: string().required(),
            codpos: string().required().min(5).test('len', 'Must be exactly 5 characters', (val: any) => val?.length === 5),
            ciudad: string().required(),
            estado: string().required(),
          }),
        })
      });

    default:
      return object({
        Escuela: object({
          DatosInstitucion: object({
            nombre: string().required(),
            descripcion: string(),
            direccion: string(),
            numero: string(),
            colonia: string(),
            cp: string().required().min(5),
            edo: string(),
            pais: string().required(),
            telefono: number().required(),
            email: string(),
            logo: mixed()
              .test("FILE_SIZE", "La imagen excede el peso y tamaño permitidido.",
                value => !value || (value && value.size <= FILE_SIZE))
              .test("FILE_FORMAT", "La imagen tiene un formato invalido.",
                value => !value || (value && SUPPORTED_FORMATS.includes(value.type))),
            numero_alumnos: number().required(),
            zona_horaria: string().required(),
            hora_salida: string(),
          }),
          Usuario: object({
            nombre: string().required(),
            apellido: string().required(),
            email: string().required().email(),
            password: string().required('Password is required').min(3),
            //  mobil: string().required().min(10).max(15)
          }),
        })
      });
  }

};

const selectComponentByTypeRol = (step: number, props: any) => {

  const type: string = `ESCUELA_${step}`;

  switch (type) {
    case `ESCUELA_0`:
      return <DatosInstitucion {...props} />;
    case `ESCUELA_1`:
      return <Usuario {...props} />;
    case `ESCUELA_2`:
      return props?.rolTypeRegister === 'MEXICO' ? <DatosFacturacion {...props} /> : <Pago {...props} />;
    case `ESCUELA_3`:
      return <Pago {...props} />;
  }

};

const selectSaveComponentByTypeRol = (step: number, props: any) => <SaveAlumno {...props} />;

const getStepContent = ({ step, props }: { step: number, props: any }) => {
  switch (step) {
    case 0:
      return selectComponentByTypeRol(step, props);
    case 1:
      return selectComponentByTypeRol(step, props);
    case 2:
      return selectComponentByTypeRol(step, props);
    case 3:
      return selectComponentByTypeRol(step, props);
    case 4:
      return selectSaveComponentByTypeRol(step, props);
    default:
      return 'Sección invalida';
  }
};


export const StepperRegister = () => {

  const classes = useStyles();

  const history = useHistory();

  const query = useQuery();
  const canceled: any = query.get("canceled");  //
  const registerSchoolKidkiriki: any = localStorage.getItem('registerSchoolKidkiriki');

  const [rolTypeRegister, setRolTypeRegister] = useState('MEXICO' as string);
  const steps: any = getSteps(rolTypeRegister);
  const [showLoading, setShowLoading] = useState(false as boolean);
  const [activeStep, setActiveStep] = useState(JSON.parse(registerSchoolKidkiriki) ? (steps.length - 1) : 0);

  const [showAlert, setShowAlert]: any = useState({
    dspAlert: false,
    title: '',
    message: '',
    subHeader: '',
    redirect: false
  });


  const success: any = query.get("success");  // success of stripe
  const sessionIdStripe: any = query.get("session_id");  // session of stripe

  const handleNext = () => setActiveStep((prevActiveStep) => prevActiveStep + 1);

  const handleBack = () => setActiveStep((prevActiveStep) => prevActiveStep - 1);


  // `${apiUrl}/v1/AutoRegister/create/${rolTypeRegister}


  useEffect(() => {
    if (!success) return;

    var formData = new FormData();

    formData.append('data', JSON.stringify({
      orderID: sessionIdStripe,
      ...formik.values,
    }));

    formData.append('logo', formik.values.Escuela.DatosInstitucion.logo);

    fetch(`${apiUrl}/index.php/Stripe/saveSubscription`, {
      method: "POST",
      body: formData
    })
      .then(response => response.text())
      .then(er => {
        alert(`¡Felicidades! 
                    Has completado tu registro, en breve recibirás un correo con los pasos a seguir 
                    ¡Bienvenidos a la familia Kidkiriki!
                `);
        return window.location.href = 'https://kidkiriki.com/admin_beta';
      })
      .catch((err) => console.error(err));
  }, [success]);


  const formik = useFormik({
    initialValues: ((process.env.NODE_ENV !== 'development') ?
      ((canceled || success) ? JSON.parse(registerSchoolKidkiriki) : initialValues) : ((canceled || success) ? JSON.parse(registerSchoolKidkiriki) : testInitialValues)),
    validationSchema: selectValidationSchema(rolTypeRegister),
    onSubmit: (values: any, { setSubmitting, submitForm, }) => {
      const stripeForm: any = document.getElementById('stripeForm');
      stripeForm.submit();
      setShowLoading(true);
      /* return fetch(`${apiUrl}/index.php/Stripe/saveSubscription`, {
         method: 'POST',
         body: registerSchoolKidkiriki
       })
         .then((res: any) => res.json())
         .then((data): void => {
           console.log(data);
           setShowLoading(false);
 
           if (type === 'success') return setShowAlert({
             ...showAlert,
             dspAlert: true,
             title: '¡Éxito!',
             message: `Te has registrado en Kinder, recibirás un correo de bienvenida cuando tu cuenta sea verifcada por la Institución.`,
             redirect: {
               isRedirect: true,
               url: '/',
             }
           });
 
           setSubmitting(false);
 
           setShowAlert({
             ...showAlert,
             dspAlert: true,
             title,
             message,
           });
 
         })
         .catch((err: any) => console.error(err))*/
    }
  });
  //console.log(formik)


  return (
    <div className={classes.root}>
      {showLoading && (<IonProgressBar type="indeterminate" />)}
      <IonAlert
        isOpen={showAlert?.dspAlert}
        onDidDismiss={(): void => showAlert.redirect ? history.replace('/') : setShowAlert({ ...showAlert, dspAlert: false })}
        cssClass='my-custom-class'
        header={showAlert?.title}
        message={showAlert?.message}
        buttons={['OK']}
      />
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((label: string, index: number) => (
          <Step key={label}>
            <StepLabel style={{ fontWeight: 'bold' }} >
              {label}
            </StepLabel>
            <StepContent>
              <FormikProvider value={formik}>
                <form onSubmit={formik.handleSubmit}>
                  {getStepContent({
                    step: index,
                    props: {
                      steps: steps.length - 1,
                      handleNext,
                      handleBack,
                      formik,
                      rolTypeRegister,
                      setRolTypeRegister,
                      FormikProvider,
                      FieldArray
                    }
                  })}
                </form>
              </FormikProvider>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </div >
  );
}